import React, { useEffect } from 'react';
import { Button, FormGroup, Label, Input, } from 'reactstrap';
import { omit, isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import env from '../../env';
import { prefectures, } from '../../shared/config';
import { fields } from '../../shared/models/extraSeller';
import { getAddressByPostalCode, } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import Page from '../hocs/Page';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import SettingsTabs from '../SettingsTabs';

const { entries } = Object;

export default Page(function SettingsExtraSellers (props) {
  const { tenant } = props;
  const extraSellersRef = tenant.ref.collection('extraSellers');
  const extraSellers = useCollectionSubscription(extraSellersRef.orderBy('createdAt'), [tenant.id]);

  return (
    <div className="settings-extraSellers container-fluid">
      <div className="p-4 bg-white my-4">
        <SettingsTabs activeTab="extraSellers" />
        {
          tenant.tenantOptionValues?.includes('multiSellers') ? (
            <div>
              <div className="d-flex justify-content-start mb-3">
                <AddButton itemRef={extraSellersRef.doc()} FormModal={ModelFormModal} formProps={{ title: 'ショップ 追加', fields, }} />
              </div>
              <div className="mt-3 overflow-auto">
                {
                  extraSellers.length > 0 ? (
                    <table className="table sticky-table table-bordered">
                      <thead className="thead-light text-center">
                        <tr className="text-nowrap">
                          <th style={{ minWidth: 200 }}>識別名</th>
                          <th style={{ minWidth: 200 }}>AmazonセラーID</th>
                          <th>認証状態</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          extraSellers.map((extraSeller) => {
                            const { id, ref, name, spId, spApi, } = extraSeller;

                            return (
                              <tr key={id}>
                                <td>
                                  {name}
                                </td>
                                <td>
                                  {spId}
                                </td>
                                <td>
                                  {spApi?.accessToken != null ? <div className="text-success">認証済み</div> : <div className="text-danger">未認証</div>}
                                </td>
                                <td className="text-right text-nowrap">
                                  <EditButton className="ml-2" itemRef={ref} FormModal={ModelFormModal} formProps={{ title: 'ショップ 編集', fields, }} />
                                  <DeleteButton item={extraSeller} itemRef={ref} className="ml-2" />
                                </td>
                              </tr>
                            );
                          })
                        }
                      </tbody>
                    </table>
                  ) : (
                    <div>
                      ショップは未登録です
                    </div>
                  )
                }
              </div>
            </div>
          ) : (
            <div className="alert alert-warning">
              複数ショップをAPI連携したい場合はお問い合わせまでご連絡くださいませ。
            </div>
          )
        }
      </div>
    </div>
  );
});
